import React, { useState, useMemo } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import axios from "axios";
import CommonTable from "../../../common/CommonTable";

const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL || 'http://127.0.0.1:8000/';

const DPBlackspot = () => {
  const [selectedYears, setSelectedYears] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  // Dynamically generate years from 2020 to current year (2025)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2020 + 1 }, (_, i) => ({
    name: (currentYear - i).toString(),
    value: (currentYear - i).toString(),
  }));

  const handleBlackSpotSearch = async (e) => {
    e.preventDefault();
    if (!selectedYears.length) {
      alert("Please select at least one year.");
      return;
    }
    setLoading(true);
    setHasSearched(true);

    const payload = {
      year: selectedYears,
    };

    try {
      const response = await axios.post(
        `${backendUrl}roadaccident/filter_blackspot_details/`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200) {
        setFilterData(response.data);
      } else {
        console.error("Failed to fetch filtered data");
        setFilterData([]);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setFilterData([]);
      alert("Error fetching data: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(() => [
    { key: 'SlNo', label: 'S.No' },
    { key: 'year', label: 'Year', sortable: true },
    { key: 'municipality', label: 'Municipality', sortable: true },
    { key: 'submunicipality', label: 'Sub-Municipality', sortable: true },
    { key: 'suco', label: 'Suco', sortable: true },
    { key: 'roadtype', label: 'Road Type', sortable: true },
    { key: 'location', label: 'Location' },
    { key: 'latitude', label: 'Latitude', align: 'right' },
    { key: 'longitude', label: 'Longitude', align: 'right' },
    {
      key: 'datetime',
      label: 'DateTime',
      sortable: true,
      render: (row) => row.datetime || '-',
    },
    { key: 'numberofaccidents', label: 'Number of Accidents', align: 'right' },
    { key: 'numberofinjured', label: 'Number of Injured', align: 'right' },
    { key: 'numberoffatal', label: 'Number of Fatalities', align: 'right' },
  ], []);

  return (
    <>
      <div className="formcontainer1">
        <Form onSubmit={handleBlackSpotSearch}>
          <Row className="align-items-center">
            <Col md={6}>
              <Form.Group controlId="formGroupYear" className="d-flex align-items-center gap-3">
                <Form.Label className="mb-0">Year</Form.Label>
                <MultiSelect
                  value={selectedYears}
                  onChange={(e) => setSelectedYears(e.value)}
                  options={years}
                  optionLabel="name"
                  placeholder="Select Year(s)"
                  display="chip"
                  className="w-full md:w-20rem"
                  style={{ width: "400px", fontSize: "13px" }}
                />
              </Form.Group>
            </Col>
            <Col md={6} className="d-flex gap-3">
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? "Searching..." : "Search"}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
      {hasSearched && (
        <div className="formcontainer1 mt-4">
          <CommonTable
            tableData={filterData}
            columns={columns}
            searchableKeys={['municipality', 'submunicipality', 'suco', 'roadtype', 'location']}
            tableName="Blackspot_Directory"
            emptyMessage="No black spot records found."
          />
        </div>
      )}
    </>
  );
};

export default DPBlackspot;
